// extracted by mini-css-extract-plugin
module.exports = {"bubbles":"BubblesBg-module--bubbles--1maWh","bubble":"BubblesBg-module--bubble--29sO_","fly":"BubblesBg-module--fly--3S6ML"};